/**
 * @file Collision layers.
 *
 * Each collider declares the layer it belongs to and a mask of the layers it
 * may interact with, so a new interaction is a data change rather than an edit
 * to the collision system (GDD §23).
 *
 * Lives in its own module because the weapon and enemy tables need it and
 * importing the whole game config for one enum would be a needless cycle.
 *
 * @readonly
 * @enum {number}
 */
export const Layer = Object.freeze({
  WALL: 1 << 0,
  PLAYER: 1 << 1,
  ENEMY: 1 << 2,
  PLAYER_BULLET: 1 << 3,
  ENEMY_BULLET: 1 << 4,
  PICKUP: 1 << 5,
  /** A weapon in mid-air after being thrown; blocked by walls, stuns enemies. */
  THROWN_WEAPON: 1 << 6
});
